import { render, staticRenderFns } from "./Clases.vue?vue&type=template&id=011603ab&scoped=true"
import script from "./Clases.vue?vue&type=script&lang=js"
export * from "./Clases.vue?vue&type=script&lang=js"
import style0 from "./Clases.vue?vue&type=style&index=0&id=011603ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011603ab",
  null
  
)

export default component.exports